import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { Card } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiTypography from "components/SuiTypography";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";

import { AccountContext } from "context/account";
import api from "services/api";
import toast from "react-hot-toast";
import CancelIcon from "@mui/icons-material/Cancel";
import Prompt from "components/UpStyled/Prompt";
import { Tag } from "antd";

const RecentWorkCard = ({
  index,
  image,
  title,
  handleClick = () => {},
  className = "",
  badge,
  badgeColor = "cyan",
  ...rest
}) => {
  const [isHover, setIsHover] = useState(false);

  return (
    <div style={{ width: "100%" }} className={className}>
      <div
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        style={{ width: "100%" }}
      >
        <SuiBox
          onClick={handleClick}
          sx={{
            cursor: "pointer",
            backgroundImage: ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
              `${linearGradient(
                rgba(gradients.secondary.state, 0.1),
                rgba(gradients.secondary.state, 0.1)
              )}`,
            boxShadow: ({ boxShadows: { lg } }) => (isHover ? lg : "none"),
            borderRadius: ({ borders }) => borders.borderRadius.md,

            overflow: "hidden",
            position: "relative",
            m: 1,
            display: "block",
            minWidth: 0,
            width: "100%",
            ...rest?.sx,
          }}
          className="hover-parent"
        >
          <ImageCardWrapper
            data={image}
            height={512}
            width={512}
            style={{
              height: "auto",
              width: "100%",
            }}
            sx={{
              display: "flex",
            }}
            draggable={false}
            {...rest}
          />
          {badge ? (
            <Tag
              color={badgeColor}
              style={{ cursor: "pointer", position: "absolute", top: 5, right: 5 }}
            >
              {badge}
            </Tag>
          ) : null}

          <SuiBox className="overlay">
            <SuiBox display="flex" alignItems="center" gap={1}>
              <SuiTypography
                variant="body1"
                textTransform="none"
                color="white"
                sx={{
                  fontWeight: "bold",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: "2",
                  WebkitBoxOrient: "vertical",
                }}
              >
                {title}
              </SuiTypography>{" "}
            </SuiBox>
          </SuiBox>
        </SuiBox>
      </div>
    </div>
  );
};
export default RecentWorkCard;
